import Script from 'next/script';
import styles from './styles.module.css';

type Props = {
  portalId: string;
  formId: string;
  region: string;
};

const HubspotFormBlock = ({ portalId, formId, region }: Props) => {
  return (
    <section className={styles.wrapper}>
      <Script src={`https://js.hsforms.net/forms/embed/${portalId}.js`} strategy="afterInteractive" />
      <div className="hs-form-frame" data-region={region} data-form-id={formId} data-portal-id={portalId} />
    </section>
  );
};

export default HubspotFormBlock;
